<p-card>
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Bandeja de funnel</h1>
      <p class="mb-3 text-color-secondary">
        Tus tareas de seguimiento de clientes (Omnicanal). Da clic en una tarea para ver su detalle, comentarios e historial, y avanzar su estado.
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <app-main-table [apiService]="apiService" [columns]="columns" [actions]="actions" singleEntityName="tarea" pluralEntityName="tareas" (onAction)="onAction($event)"></app-main-table>
    </div>
  </div>

  <app-funnel-task-detail [(visible)]="detailVisible" [taskId]="selectedId" (changed)="onTaskChanged()"></app-funnel-task-detail>
</p-card>
